<template>
  <div class="wrap">
    <div class="event">
      <img src="" alt="" class="eventImg" />
      <div class="eventTitle">最新活动</div>
      <div class="eventEn">RECENT ACTIVITIES</div>
      <div class="eventBox">
        <img :src="nav.pcPhoto" alt="" class="eventBoxImg" />
        <div class="eventBoxRight">
          <div class="eventBoxTitle">{{ nav.title }}</div>
          <div class="eventBoxDetail">{{ nav.detail }}</div>
          <div @click="jumpLink(nav.path)" class="eventBoxInspect">查看详情</div>
          <Btn :navArr="arr" :style="styleBtn" :size="btnSize" @fetchNav="fetchNav" />
        </div>
      </div>
    </div>
    <img src="https://p1.ssl.qhimg.com/t110b9a9301e3cc9ef666635102.png" alt="" class="eventImg" />
  </div>
</template>

<script setup>
import Btn from '@/components/common/2024/button.vue'
import { ref } from 'vue'
const styleBtn = {
  position: 'absolute',
  right: '48px',
  // bottom: '72px'
  bottom: '6%'
}

const btnSize = {
  width: '68px',
  height: '48px'
}

const props = defineProps(['arr'])
const arr = props.arr || {}

let nav = ref(arr[0])
let currentIdx = ref(0)
const jumpLink = (url) => {
  if(url) {
    window.open(url, '_blank');
  }
}
function fetchNav(newId) {
  nav.value = arr[newId]
}
</script>

<style lang="scss" scoped>
.wrap {
  opacity: 1;
  background-color: #f3f3f3;
  padding: 63px 0 90px;
  position: relative;
  // background-color: pink;
}

.event {
  width: 90%;
  min-width: 1230px;
  margin: 0 auto;
  z-index: 20;
  &Img {
    position: absolute;
    top: 0;
    right: -96px;
    width: 400px;
  }
  &Title {
    font-family: Source Han Sans;
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    margin-top: 16px;
    margin-bottom: 110px;
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    display: inline-block;
  }
  &Box {
    // height: 525px;
    border-radius: 32px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(120px);
    display: flex;
    &Img {
      // width: 1000px;
      width: 62%;
    }
    &Right {
      width: 600px;
      position: relative;
      border-radius: 0 32px 32px 0;
      // background-color: pink;
      padding: 5% 39px;
    }
    &Title {
      font-family: Source Han Sans;
      font-size: 28px;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-9 */
      color: #242933;
    }
    &Detail {
      font-family: Source Han Sans;
      font-size: 18px;
      font-weight: normal;
      line-height: 36px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-8 */
      color: #525966;
      margin: 40px 0 0;
    }
    &Inspect {
      position: absolute;
      // bottom: 79px;
      bottom: 8%;
      width: 126px;
      height: 50px;
      text-align: center;
      cursor: pointer;
      border-radius: 16px;
      opacity: 1;
      box-sizing: border-box;
      border: 1px solid #e2e6ed;
      font-family: Source Han Sans;
      font-size: 18px;
      font-weight: normal;
      line-height: 50px;
      letter-spacing: 0px;
      /* Gray 中性/gray-8 */
      color: #525966;
    }
    &Inspect:hover {
      border: 1px solid #497ced;
      color: #497ced;
    }
  }
}
</style>
